import { render, staticRenderFns } from "./technicalStatistics.vue?vue&type=template&id=58b074e4"
import script from "./technicalStatistics.vue?vue&type=script&lang=js"
export * from "./technicalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports